import React from 'react'
import img7 from '../images/case-8.jpeg'
import img8 from '../images/case-9.jpeg'
import '../style/result.css'

const CaseStudyPage2 = () => {
  return (
    <>
      <div className='container' id='caseStdC'>
        <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: "50px", color: 'rgb(13, 92, 126)' }}>CASE STUDY</h2>
        <div className='row' id='rM2'>
          <div className='col-md-4' id='caseConta'>
            <img id='caseSt' src={img7} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
            <h4 style={{ marginTop: "20px" }}>Mr. Naresh Gupta</h4>
            <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>SAI CHEMICALS</h6>
          </div>
          <div className='col-md-8' id='innerCase'>
            <div className='row' id='rowCase' >
              <div className='col' >
                <span style={{ color: 'black', width: '50px' }}>
                  <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING 🙁</h4>
                  <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                    <li>Running a 15-year-old business, Naresh started with a small team of 10, facing several challenges such as a lack of proper marketing and accounting systems, undefined employee and partner roles, and no defined sales process. 😰</li>
                    <li>With a turnover of 6 crores in 2020-21, he grappled with low margins in volume sales, funding issues, team management problems, delivery system inefficiencies, and stiff competition. 😓</li>
                  </ul>
                </span>
              </div>
              <div className='col' >
                <span style={{ color: 'black', width: "100px" }}>
                  <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING 🤩</h4>
                  <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                    <li> Post coaching, Naresh catapulted the turnover for 2022-23 to 9 crores, representing a phenomenal 50% growth in a single year. In Q1 of 2023-24 alone, he's already achieved 3.5 crores in revenue, another 50% growth, with a target of 12 crores for the year!🔥</li>
                    <li>Naresh Chemical now operates on a semi-automatic model, with the team handling all activities smoothly. 🏭🔄</li>
                    <li>Proper accounting systems and practices were established,
                      fostering transparency and <br />financial health.💰📘</li>
                  </ul>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className='row' id='rM21'>
          <div className='col-md-4' id='caseConta'>
            <img id='caseSt' src={img8} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
            <h4 style={{ marginTop: "20px" }}>Mr Shishir Khedkar</h4>
            <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>Splashjet Inkjet Ink Pvt. Ltd.</h6>
          </div>
          <div className='col-md-8' id='innerCase'>
            <div className='row' id='rowCase' >
              <div className='col' >
                <span style={{ color: 'white', width: '50px' }}>
                  <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING 🌧️</h4>
                  <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                    <li>Despite having 15+ years of experience and a 10-crore business, Shishir felt stuck in stagnant growth, micromanaging, and overseeing a staff of 100+ 😖</li>
                    <li>Swamped with daily operations, he worked long hours and struggled to seize new opportunities due to time constraints 😣</li>
                    <li>With five different verticals, Shishir lacked proper reporting or systems to track progress 📉</li>
                  </ul>
                </span>
              </div>
              <div className='col' >
                <span style={{ color: 'white', width: "100px" }}>
                  <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING 💡</h4>
                  <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                    <li>Shishir achieved an astonishing 83% growth in just one year! FY 22-23 revenue skyrocketed to 18.3 crores from 10 crores in FY 21-22 🔥</li>
                    <li>He mastered the art of acquiring new customers and added three new segments to his business 💼🎯</li>
                    <li>With a solid marketing setup in place, Shishir has doubled his marketing budget this year to tap into an increased market share and build his brand 🚀🔝💰</li>
                  </ul>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className='pageNo' style={{ marginTop: '25px', textAlign: "center", marginLeft: '5px' }}>
          <h4>Page No.</h4>
        </div>
        <div className='row' style={{ marginTop: '25px', marginBottom: '20px' }}>
          <div className='col' style={{ textAlign: 'end' }}>
            <a href='/CaseStudy'>
              <h2 style={{ border: "1px solid black", display: 'inline-block', paddingLeft: '6px', paddingRight: '6px', paddingT: '2px', paddingBottom: '2px' }}>1</h2>
            </a>
          </div>
          <div className='col' style={{ textAlign: 'start' }}>
            <a href='/CaseStudy-2'>
              <h2 style={{ border: "1px solid black", display: 'inline-block', paddingLeft: '6px', paddingRight: '6px', paddingT: '2px', paddingBottom: '2px' }}>2</h2>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default CaseStudyPage2
